import { NgModule } from '@angular/core';
import { ModuleWithProviders } from '@angular/core';
import { Constants, SharedCoreModule } from '@tt-chvac/core';

@NgModule({
})
export class SharedCoreLibraryModule {

  public static forRoot(environment: any, cachedDbConfig: any): ModuleWithProviders<SharedCoreModule> {

    return {
      ngModule: SharedCoreModule,
      providers: [
        Constants,
        {
          provide: 'environment',
          useValue: environment,
        },
        {
          provide: 'cachedDbConfig',
          useValue: cachedDbConfig
        }
      ],
    };
  }
}
